import { render, staticRenderFns } from "./settings-damage-assessment.vue?vue&type=template&id=d66f8a98&scoped=true"
import script from "./settings-damage-assessment.vue?vue&type=script&lang=js"
export * from "./settings-damage-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66f8a98",
  null
  
)

export default component.exports